import VanillaFittty from "shared/scripts/vanilla_fittty"
import { singularizeStepType } from "shared/lib/utils"

const ServiceTabs = async () => {
  const serviceTabsData = JSON.parse(document.querySelector("[data-service-tabs]")?.dataset?.serviceTabs || "{}")
  const { signedIn, myAppletsUrl, discoverAppletsUrl, discoverMoreAppletsUrl, currentTab } = serviceTabsData

  const loadApplets = async (url:string, containerClass:string, loadingMore:boolean = false) => {
    const appletContainer = document.querySelector(`section[data-tab] ${containerClass}`)

    if (!appletContainer) return

    if (loadingMore) {
      appletContainer.parentElement?.classList.add("loading")
    }

    await fetch(url)
      .then(response => response.text())
      .then(html => {
        if (loadingMore) {
          appletContainer.parentElement?.classList.remove("loading")
          appletContainer.insertAdjacentHTML("beforeend", html)
        } else {
          appletContainer.classList.remove("loading")
          appletContainer.insertAdjacentHTML("afterbegin", html)
        }
      })
  }

  const loadMoreApplets = async () => {
    const loadMoreButton = document.querySelector("#load-more-applets")
    if (!loadMoreButton) return

    loadMoreButton.addEventListener("click", async () => {
      loadMoreButton.parentElement?.remove()
      await loadApplets(discoverMoreAppletsUrl, ".discover_services .web-applet-cards", true)
    })
  }

  // Signed-out users load Applets in backend and it's cached. It doesn't have my Applets.
  if (signedIn) {
    if (currentTab === "my_applets") {
      await loadApplets(myAppletsUrl, ".my_applets")
      await loadApplets(discoverAppletsUrl, ".discover_services")
    } else {
      await loadApplets(discoverAppletsUrl, ".discover_services")
      await loadApplets(myAppletsUrl, ".my_applets")
    }

    loadMoreApplets()
  } else {
    loadMoreApplets()
  }

  // Tab switching for TQA module
  document.querySelectorAll(".tab-content.filters a").forEach(tab => {
    tab.addEventListener("click", (event) => {
      event.preventDefault()
      const tab = event.target.closest("a")

      if (tab.classList.contains("active")) return

      document.querySelectorAll(".tab-content.filters a").forEach(tab => tab.classList.remove("active"))
      tab.classList.add("active")

      const tabContent = document.querySelector(`section[data-tab=${tab.dataset.target}]`)
      document.querySelectorAll("section[data-tab]").forEach(content => content.classList.add("hide"))
      tabContent?.classList.remove("hide")

      VanillaFittty(tabContent)

      window.history.replaceState({ url: tab.href }, "", tab.href)
    })
  })

  document.querySelectorAll(".tqas-tab-nav .tqa-tab").forEach(tab => {
    tab.addEventListener("click", (event) => {
      event.preventDefault()
      const clickedTab = event.currentTarget
      if (!(clickedTab instanceof HTMLElement)) return
      if (clickedTab.classList.contains("active")) return

      document.querySelectorAll(".tqas-tab-nav .tqa-tab").forEach(t => t.classList.remove("active"))
      clickedTab.classList.add("active")

      document.querySelectorAll(".tqas-tab-panel").forEach(panel => panel.classList.remove("active"))

      const tabKey = clickedTab.getAttribute("data-tab")
      const activePanel = document.querySelector(`.tqas-tab-panel[data-tab-panel="${tabKey}"]`)
      if (activePanel) activePanel.classList.add("active")

      const countElement = document.querySelector(".tqa-count")
      if (countElement && activePanel) {
        const itemCount = activePanel.querySelectorAll(".tqa-card").length
        let itemType: string
        if (tabKey === "all") {
          itemType = "triggers, queries, and actions"
        } else if (itemCount === 1) {
          itemType = singularizeStepType(tabKey)
        } else {
          itemType = tabKey ?? ""
        }
        countElement.textContent = `${itemCount} ${itemType}`
      }
    })
  })
}

export default ServiceTabs
